import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
              最新资讯
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              使用技巧、问题解决、内容推荐，全面了解蘑菇视频网页版
            </p>
          </div>
          <Link
            to="/article/mogu-video-web-version-access-guide"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline flex flex-col"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-secondary-500 text-background-50 whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 font-label line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-2 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/70">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-eye-line"></i>
                    {article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/article/mogu-video-web-version-access-guide"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}